import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { requireAuthenticatedUser } from '../../decorators'
import type { THrid } from '~/types/models'

// post

interface PostFeedbackResponse {
  hrid: THrid
}

const postFeedback = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  const newEntityData = await req.json()
  const responseBody: PostFeedbackResponse = { hrid: newEntityData.id.slice(2) }
  return res(ctx.status(201), ctx.json(responseBody))
}

export const handlers = [
  {
    method: 'post',
    path: '/api/feedback',
    handler: postFeedback,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
